export const iconFontAwesomeDesignPaintbrush = (
	<i className="fa-solid fa-paintbrush"></i>
);
